/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { FORM_NAME } from '../../constants';
import {
	getFormInitialValuesSelector,
	getIsActiveSelector,
	getIsReqInfoLoadingSelector,
	getReqInfoSelector,
} from '../../selectors';
import { validate } from '../../utils';
import { CargoFetchFormView } from './cargo-fetch-form-view';

const CargoFetchFormWrapper = ({ reqInfo, isReqInfoLoading, isActive }) => {
	return <CargoFetchFormView reqInfo={reqInfo} isReqInfoLoading={isReqInfoLoading} isActive={isActive} />;
};

const withForm = reduxForm({
	form: FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(CargoFetchFormWrapper);

const mapStateToProps = createStructuredSelector({
	initialValues: getFormInitialValuesSelector(),
	reqInfo: getReqInfoSelector(),
	isReqInfoLoading: getIsReqInfoLoadingSelector(),
	isActive: getIsActiveSelector(),
});

const CargoFetchForm = connect(mapStateToProps)(withForm);

CargoFetchFormWrapper.propTypes = {
	reqInfo: PropTypes.object,
	isReqInfoLoading: PropTypes.bool,
	isActive: PropTypes.object,
};

export { CargoFetchForm };
